// extracted by mini-css-extract-plugin
export default {"tab":"navbar_tab__jbW8J","tabs":"navbar_tabs__0dZWK"};